export default function AureliaCopyright() {
  const year = new Date().getFullYear();
  return (
    <footer className="pr-copyright">
      <p>
        © {year}{" "}
        <a href="https://aureliasuite.fr" target="_blank" rel="noopener noreferrer">
          Aurélia Suite
        </a>
        . Tous droits réservés
        <span className="pr-copyright__sep" aria-hidden>
          •
        </span>
        Conforme RGPD
        <span className="pr-copyright__sep" aria-hidden>
          •
        </span>
        Studio Seth — Pacy-sur-Eure (27)
      </p>
    </footer>
  );
}
